export default __webpack_public_path__ + "static/media/image-work-company-w@3x.68fae8c0.webp";